import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../../../utils/withDefaults';
const RootRoot = styled(Button)(({
  theme
}) => ({
  margin: theme.spacing(4, 0, 1, 0)
}));
export const Root = withDefaults(RootRoot, {
  fullWidth: true,
  type: 'submit',
  color: 'aqua',
  size: 'lg'
});